import * as yup from "yup";

const actionItemTagValidationSchema = yup.object().shape({
  name: yup.string().min(2).max(255).required("Name is required"),
  color: yup.string().min(2).max(255).required("Color is required"),
  description: yup.string().nullable().notRequired(),
});

export default actionItemTagValidationSchema;
